<template>
    <div>
        <mc-table-pro
            ref="tableRef"
            name="SellingPointDesclist"
            :source="innerValue"
            :columns="columns"
            :pagination="false"
            v-bind="$attrs"
            style="width:99%"
        >
            <template
                slot="sellPointKeyDesc"
                slot-scope="scope"
            >
                <mc-input
                    v-model="scope.row.sellPointKeyDesc"
                    maxlength="10"
                    :disabled="disabled"
                />
            </template>

            <template
                slot="sellPointContentDesc"
                slot-scope="scope"
            >
                <mc-input
                    v-model="scope.row.sellPointContentDesc"
                    type="textarea"
                    :disabled="disabled"
                    maxlength="100"
                />
            </template>

            <template
                slot="operation"
                slot-scope="scope"
            >
                <McOptionButtons
                    :source="scope"
                    :button-render="optionButtonRender"
                />
            </template>
        </mc-table-pro>
    </div>
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api';

const columns = Object.freeze([
    {
        label: '卖点关键词',
        prop: 'sellPointKeyDesc',
        template: {
            component: 'mc-input',
            attrs: {
                maxlength: '10',
                placeholder: '请输入卖点',
            },
        },
        width: 210,
    },
    {
        label: '卖点描述',
        prop: 'sellPointContentDesc',
        template: {
            component: 'mc-input',
            attrs: {
                type: 'textarea',
                placeholder: '请输入卖点描述',
                maxlength: '100',
            },
        },
    },
    {
        label: '操作',
        prop: 'operation',
        width: 80,
    },
].map((v) => ({ ...v, align: 'center' })));

export default {
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();

        const innerValue = computed({
            get() {
                return props.value;
            },
            set(val) {
                proxy.$emit('input', val);
            },
        });

        // 操作
        const optionButtonRender = (row) => [{
            label: '删除',
            type: 'button',
            permission: !props.disabled,
            clickFn: () => {
                innerValue.value.splice(row.$index, 1);
            },
        }];

        return {
            columns,

            innerValue,
            optionButtonRender,
        };
    },
};
</script>

<style lang="scss" scoped>
::v-deep .mc-input-wrapper {
    width: 100%;
}
::v-deep .mtd-textarea {
    width: 100%;
}
</style>
